import React, { useState } from "react";
import Editor from "ckeditor5-custom-build";
// import CKEditor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { APIClient } from "../helpers/api_helper";
import { API_IMAGE_INSERT } from "../helpers/url_helper";
import { uploadImage } from "../helpers/helper";

const api = new APIClient();

export const UploadService = async (formData) => {
  try {
    const response = await api.createWithFormData(API_IMAGE_INSERT, formData);
    return response.data;
  } catch (error) {
    return error;
  }
};
function CKEditorCustom({ onChange, valueName, refId }) {
  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file.then(async (file) => {
            // Add 'async' keyword here
            var formData = new FormData();
            formData.append("image", file);
            const upload = await uploadImage(formData);
            let data =
              `${process.env.REACT_APP_IMAGE_URL}uploads/images/` +
              upload.data.imageName;
            resolve({
              default: data,
            });
          });
        });
      },
    };
  }
  function CustomUploadAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <CKEditor
      config={{
        extraPlugins: [CustomUploadAdapterPlugin],
      }}
      editor={Editor}
      data={valueName}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
    />
  );
}

export default CKEditorCustom;
